module.exports = __webpack_public_path__ + "img/shuangfeng.a1404d6b.jpg";